// src/config.ts

const config = {
  phone: "+40722762291",
  email: "info@uniart.ro",
  facebookPage: "https://www.facebook.com/profile.php?id=100066755643219",
  linkedInPage: "https://www.linkedin.com", // Alapértelmezett LinkedIn oldal
  developerLinkedIn:
    "https://www.linkedin.com/in/p%C3%A9ter-m%C3%A1rk-114036273/",
  pinterestPage: "https://www.pinterest.com", // Alapértelmezett Pinterest oldal
  wazeUrl: `https://www.waze.com/live-map/directions/ro/cj/calarasi/uniart-s.r.l.?navigate=yes&to=place.ChIJC44sAg9eSUcRh3x1ZBovmJo`,
  googleMapsAddressLink: `https://www.google.com/maps/place/Uniart+S.R.L./@46.4823852,23.8624532,17z/data=!3m1!4b1!4m6!3m5!1s0x47495e0f022c8e0b:0x9a982f1a64757c87!8m2!3d46.4823816!4d23.8673241!16s%2Fg%2F1hc17dzv8?entry=ttu&g_ep=EgoyMDI1MDIxOS4xIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D`,
  address: "com. Călărași (sat. Călărași), jud. Cluj, România",
  mapEmbedUrl:
    "https://www.openstreetmap.org/export/embed.html?bbox=23.8573,46.4724,23.8773,46.4924&layer=mapnik&marker=46.4824,23.8673",
  cui: "RO26292626",
  j_number: "J12/2296/04.12.2009",
  legal_name: "SC UNIWOOD SRL",
  postal_code: "407130",
};

export default config;
